// extracted by mini-css-extract-plugin
module.exports = {"mobile":"360","tablet":"768","desktop":"1280","container":"_2l3_A","title":"Sz64k","description":"HY9Fc","doc":"Crkf3","link":"_2CIk4","icon":"_2UkGk"};